import { useCallback, useState } from "react";
import axiosInstance from "@/hooks/axios";
import { isAxiosError } from "axios";
import { User } from "@/types/user";

export interface ConfirmEmailData {
  email: User["email"];
  token: string;
}

export interface ConfirmEmailResponse {
  success: boolean;
  message: string;
}

export const useConfirmEmailPassword = () => {
  const [data, setData] = useState<ConfirmEmailResponse | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const confirmEmail = useCallback(async (formData: ConfirmEmailData) => {
    setLoading(true);
    setError(null);

    try {
      const response = await axiosInstance.post<ConfirmEmailResponse>(
        "users/users/confirm_email/",
        formData,
      );

      setData(response.data);
    } catch (err: unknown) {
      if (isAxiosError(err)) {
        setError(err.message);
      } else if (err instanceof Error) {
        setError(err.message);
      } else {
        setError("An unknown error occurred.");
      }
    } finally {
      setLoading(false);
    }
  }, []);

  return { data, loading, error, confirmEmail };
};
